import * as api from "api/endpoints/onboarding";
import { createSlice, createSliceSelector } from "../factory";

const name = "onboardingPage";

const initialState = {
  verificationData: null,
  decisioningValues: null
};

const slice = createSlice(name, initialState);

export default slice.reducer;

/* Selectors */
const createSelector = createSliceSelector(name);

export const selectVerificationData = createSelector((state) => {
  return state.verificationData;
});

export const selectDecisioningValues = createSelector((state) => {
  return state.decisioningValues;
});

export const selectNameMatchingValues = createSelector((state) => {
  return state.nameMatchingValues;
});

/* Actions */
const { update } = slice.actions;

export function loadVerificationData(epId) {
  const config = { params: { epId: epId } };
  return async function (dispatch) {
    let data = await api.getBusinessSetup(config);
    const payload = {
      verificationData: data
    };

    dispatch(update(payload));
  };
}

export function loadDecisioningValues(epId) {
  const config = { params: { epId: epId } };
  return async function (dispatch) {
    const data = await api.getDecisioningSetup(config);

    const payload = {
      decisioningValues: data.details
    };

    dispatch(update(payload));
  };
}

export function updateDecisioningValues(changedValue) {
  return async function (dispatch, getState) {
    const data = selectDecisioningValues(getState());

    const newValues = Object.assign({}, data, changedValue);
    const payload = {
      decisioningValues: newValues
    };

    dispatch(update(payload));
  };
}

export function submitDecisioningValues(data) {
  return async function (dispatch) {
    try {
      await api.postDecisioningSetup(data);
      dispatch(loadDecisioningValues(data.epId));
    } catch (error) {
      throw error;
    }
  };
}

export function loadNameMatchingValues(epId) {
  const config = { params: { epId: epId } };
  return async function (dispatch) {
    const data = await api.getNameMatchingSetup(config);

    const payload = {
      nameMatchingValues: data.details
    };

    dispatch(update(payload));
  };
}

export function updateNameMatchingValues(changedValue) {
  return async function (dispatch, getState) {
    const data = selectNameMatchingValues(getState());

    const newValues = Object.assign({}, data, changedValue);
    const payload = {
      nameMatchingValues: newValues
    };

    dispatch(update(payload));
  };
}

export function submitNameMatchingValues(data) {
  return async function (dispatch) {
    try {
      await api.postNameMatchingSetup(data);
      dispatch(loadNameMatchingValues(data.epId));
    } catch (error) {
      throw error;
    }
  };
}
